import Vue from 'vue'

// State
const state = {
  isLoading: false,
  data: null
}

// Mutations
const fetchSignTypesRequest = 'fetchSignTypesRequest'
const fetchSignTypesResponse = 'fetchSignTypesResponse'

const mutations = {
  [fetchSignTypesRequest] (state) {
    state.isLoading = true
  },
  [fetchSignTypesResponse] (state, signTypes) {
    state.isLoading = false
    state.data = signTypes
  }
}

// Actions
export const fetchSignTypes = 'fetchSignTypes'
const actions = {
  [fetchSignTypes]: ({ commit, dispatch }) => {
    commit(fetchSignTypesRequest)
    return Vue.http
      .get(`${SERVER_URL}/signTypes`)
      .then(({ data: signTypes }) => {
        commit(fetchSignTypesResponse, signTypes)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sign-types.js